import React from "react";
import ReactAnimatedWeather from "react-animated-weather";
import { WiDayLightning, WiNightAltLightning } from "weather-icons-react";

export default function WeatherIcon(props) {
  const codemapping = {
    "01d": "CLEAR_DAY",
    "01n": "CLEAR_NIGHT",
    "02d": "PARTLY_CLOUDY_DAY",
    "02n": "PARTLY_CLOUDY_NIGHT",
    "03d": "PARTLY_CLOUDY_DAY",
    "03n": "PARTLY_CLOUDY_NIGHT",
    "04d": "CLOUDY",
    "04n": "CLOUDY",
    "09d": "RAIN",
    "09n": "RAIN",
    "10d": "RAIN",
    "10n": "RAIN",
    "11d": WiDayLightning,
    "11n": WiNightAltLightning,
    "13d": "SNOW",
    "13n": "SNOW",
    "50d": "FOG",
    "50n": "FOG",
  };

  if (codemapping[props.code] === WiDayLightning) {
    return <WiDayLightning color="#000" size={70} />;
  } else {
    if (codemapping[props.code] === WiNightAltLightning) {
      return <WiNightAltLightning color="#000" size={70} />;
    } else {
      return (
        <ReactAnimatedWeather
          icon={codemapping[props.code]}
          color="#000"
          size={70}
          animate={true}
        />
      );
    }
  }
}
